import cx from "classnames";
import type { ReactNode } from "react";
import React from "react";
import type { ButtonProps } from "react-bootstrap";
import { Button, Row } from "react-bootstrap";

import type { GlyphIcon } from "../../../../helpers";
import { getGlyphClassNames, GlyphPlacement, spacing } from "../../../../helpers";

// todo @miczhong [Task: 27299571] use Bootstrap's Toggle Button when Moray makes it with focus border
// MWF Moray doesn't support showing focus border for <ToggleButton> from React Bootstrap.
// Bootstrap <ToggleButton> is rendered as a <label> and Moray doesn't have an accessible
// component that brings focus to that <label> when tabbing through.
// Moray intake item 3184 has been created to ask for creation of an accessible component
// https://dev.azure.com/mscomdev/Moray/_workitems/edit/3184

interface IIconButtonProps {
  className?: string;
  iconClassName?: string;
  children?: ReactNode;
  iconName: GlyphIcon;
  onClick?: () => void;
  tabIndex?: number;
}

type IconButtonProps = Readonly<IIconButtonProps> &
  ButtonProps &
  React.HTMLAttributes<HTMLButtonElement>;

export const IconButton = (props: IconButtonProps) => {
  const { className, iconClassName, iconName, children, ...uniqueProps } = props;
  const glyphClassName = getGlyphClassNames(GlyphPlacement.Prepend, iconName);
  const icon = <span className={cx([glyphClassName, iconClassName])} />;

  return (
    <Button className={className} {...uniqueProps}>
      <Row className={cx(["align-items-center", spacing("margin", "all", "auto")])}>
        {icon}
        {!!children && <span className={spacing("margin", "leftRight", 2)}>{children}</span>}
      </Row>
    </Button>
  );
};
